import { useTranslation } from '../../../lib/i18n';
import { useBasePath } from '../../../lib/use-base-path';
import { useMe } from '../../../lib/me';

// Spec-conformant empty state (parity with the native apps' ChatEmptyState): the
// agent-orb cluster, a personalized title, and the one-line invitation below. When
// the profile has no first name the name is omitted gracefully.
export function EmptyLandingHero({ narrow }: { narrow: boolean }) {
  const { t } = useTranslation();
  const basePath = useBasePath();
  const me = useMe();
  const firstName = (me?.firstName ?? '').trim().split(/\s+/)[0] ?? '';
  const title = firstName
    ? t('chat.emptyState.title', { firstName })
    : t('chat.emptyState.title', { firstName: '' }).replace(/\s{2,}/g, ' ');
  return (
    <div style={{ ...WRAP, padding: narrow ? '8px 16px 22px' : '12px 48px 24px' }}>
      <img
        src={`${basePath}/chat-empty-agents.png`}
        alt=""
        aria-hidden
        width={194}
        style={{ width: 194, height: 'auto', maxWidth: '100%' }}
      />
      <div style={TITLE}>{title}</div>
      <div style={SUBTITLE}>{t('chat.emptyState.subtitle')}</div>
    </div>
  );
}

const WRAP: React.CSSProperties = {
  width: '100%',
  maxWidth: 760,
  alignSelf: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0,
  textAlign: 'center',
};

const TITLE: React.CSSProperties = {
  fontFamily: 'var(--brand-font-display)',
  fontSize: 24,
  fontWeight: 'var(--sym-weight-semibold)',
  letterSpacing: '-0.01em',
  color: 'rgba(var(--ink-rgb), 0.92)',
  lineHeight: 1.25,
  marginTop: 18,
};

const SUBTITLE: React.CSSProperties = {
  fontSize: 15,
  color: 'rgba(var(--ink-rgb), 0.55)',
  lineHeight: 1.5,
  maxWidth: 420,
  marginTop: 14,
};
